import Club from '@src/data/club'

export enum UserState {
  DEACTIVATED = 'deactivated',
  PUBLISHED = 'published'
}

export default class User {
  public id: number
  public username: string
  public email: string
  public firstName: string
  public lastName: string
  public locale: string
  public gender: 'm' | 'f'
  public club: Club
  public contactNumber: string
  public displayName: string
  public unconfirmedEmail: string
  public state: UserState

  constructor (attributes) {
    Object.assign(this, attributes)
  }

  get fullName () {
    return `${this.firstName} ${this.lastName}`
  }
}
